module.exports = __webpack_public_path__ + "img/module2-04.8b51b79e.jpg";